import useBaseMessangeAsyncSuccess from './useBaseMessageAsyncSuccess';
import useMessage from './useMessage';

function useMessageAsyncSuccess() {
  return useBaseMessangeAsyncSuccess({ hook: useMessage });
}

export default useMessageAsyncSuccess;
